module.exports = __webpack_public_path__ + "img/truck.14fdaecc.svg";